import {
	SHOW_UPLOAD_DOC,
	HIDE_UPLOAD_DOC,
	TOGGLE_HR_NUM_VERIFICATION_MODAL,
	TOGGLE_EDIT_WARNING_MODAL,
	SHOW_JOB_VERIFICATION_MODAL,
	HIDE_JOB_VERIFICATION_MODAL,
	SHOW_POC_DOC_UPLOAD_MODAL,
	HIDE_POC_DOC_UPLOAD_MODAL,
	TOGGLE_KNOW_MORE_MODAL,
	SHOW_DELETE_JOB_MODAL,
	HIDE_DELETE_JOB_MODAL,
	TOGGLE_CSV_DOWNLOAD_POPUP,
} from "../constants/ModalTypes";

const initialState = {
	uploadDoc: false,
	hrNumber: {
		open: false,
		number: "",
		jobId: null,
	},
	editWarning: {
		open: false,
		changedField: "",
		data: null,
	},
	jobVerificationModal: {
		show: false,
		showUpdateEmailOption: false,
	},
	pocDocUploadModal: false,
	knowMoreModal: false,
	deleteJobModal: {
		show: false,
		selectedJobId: null,
	},
	csvDownloadPopup: {
		showPopup: false,
		isDownloadSource: false,
		filename: "",
		jobId: "",
	},
};

const modal = (state = initialState, action) => {
	switch (action.type) {
		case SHOW_UPLOAD_DOC:
			return {
				...state,
				uploadDoc: true,
			};
		case HIDE_UPLOAD_DOC:
			return {
				...state,
				uploadDoc: false,
			};
		case TOGGLE_HR_NUM_VERIFICATION_MODAL:
			return {
				...state,
				hrNumber: {
					open: !state?.hrNumber?.open,
					number: action?.hrNumber,
					jobId: action?.jobId,
				},
			};
		case TOGGLE_EDIT_WARNING_MODAL:
			return {
				...state,
				editWarning: {
					open: !state?.editWarning?.open,
					changedField:
						action?.changedField || state?.editWarning?.changedField,
					data: action?.data || state?.editWarning?.data,
				},
			};
		case SHOW_JOB_VERIFICATION_MODAL:
			return {
				...state,
				jobVerificationModal: {
					show: true,
					showUpdateEmailOption: action.showUpdateEmailOption,
				},
			};
		case HIDE_JOB_VERIFICATION_MODAL:
			return {
				...state,
				jobVerificationModal: {
					show: false,
					showUpdateEmailOption: false,
				},
			};
		case SHOW_POC_DOC_UPLOAD_MODAL:
			return {
				...state,
				pocDocUploadModal: true,
			};
		case HIDE_POC_DOC_UPLOAD_MODAL:
			return {
				...state,
				pocDocUploadModal: false,
			};
		case TOGGLE_KNOW_MORE_MODAL:
			return {
				...state,
				knowMoreModal: action.show,
			};
		case SHOW_DELETE_JOB_MODAL:
			return {
				...state,
				deleteJobModal: {
					show: true,
					selectedJobId: action?.payload?.jobId,
				},
			};
		case HIDE_DELETE_JOB_MODAL:
			return {
				...state,
				deleteJobModal: {
					show: false,
					selectedJobId: null,
				},
			};
		case TOGGLE_CSV_DOWNLOAD_POPUP: {
			return {
				...state,
				csvDownloadPopup: {
					...action?.payload,
				},
			};
		}
		default:
			return state;
	}
};

export default modal;
